import Exceljs from 'exceljs';
import { isArray } from 'lodash';

import { TransformedEventData } from '@contentTransformation/types/contentTransformation';
import { generatedContent } from '@event/constants/generatedContent/generatedContent';
import { EventType } from '@event/types';

export const generateEmptyArray = (): TransformedEventData[] => [
  {
    type: 'title',
    data: [],
  },
  {
    type: 'description',
    data: [],
  },
  {
    type: 'userName',
    data: [],
  },
];

export const normalizeName = (name: string): string =>
  name
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase();

export const normalizeSheetData = (
  worksheet: Exceljs.Worksheet,
): Exceljs.RowValues[] => {
  const sheetData = worksheet
    .getSheetValues()
    .filter((row) => row !== null && row?.length !== 0);

  return sheetData.slice(1, sheetData.length);
};

export const pushDataToOutputArray = (
  outputArray: TransformedEventData[],
  data: string,
  type: TransformedEventData['type'],
) => {
  const outputItem = outputArray.find(
    (outputArrayItem) => outputArrayItem.type === type,
  )!;

  const typeIndex = outputArray.findIndex(
    (outputArrayItem) => outputArrayItem.type === type,
  );

  outputItem.data = [...outputArray[typeIndex].data, data];
};

export const normalizeRow = (row: Exceljs.RowValues) => {
  if (isArray(row)) {
    const title = String(row[1] || '').trim();
    const description = String(row[2] || '').trim();
    const userName = String(row[3] || '').trim();

    return {
      title,
      description,
      userName,
    };
  }

  return {
    title: '',
    description: '',
    userName: '',
  };
};

export const transformEnumValueToEnumName = (
  enumValue: EventType['typeEnumValue'] | null,
): EventType['name'] => {
  switch (enumValue) {
    case 'PUB':
      return 'Hospoda';
    case 'MEETING':
      return 'Setkání';
    case 'CULTURE':
      return 'Kultura';
    case 'SPORT':
      return 'Sport';
    case 'PARTY':
      return 'Párty';
    default:
      return 'Hospoda';
  }
};

export const getShuffledData = (
  type: TransformedEventData['type'],
  selectedEventType: EventType['typeEnumValue'] | null,
) => {
  const transformedName = transformEnumValueToEnumName(selectedEventType);
  const normalizedEventTypeName = normalizeName(transformedName);

  const transformedData = generatedContent[normalizedEventTypeName]?.find(
    (event) => event.type === type,
  );
  return transformedData?.data
    ? transformedData.data.sort(() => 0.5 - Math.random())
    : [];
};
